import React from 'react'

import InternalHero from './InternalHero';
import InternalFeatures from './InternalFeatures';
import RealWorkflow from './RealWorkflow';
import FeatureComparison from './FeatureComparison'
import PageLayout from '../PageLayout/PageLayout';

export default function ProductPage() {
  return (
    <div>
      <PageLayout fullBleed>
        <InternalHero />
        <InternalFeatures />
        <RealWorkflow />
        <FeatureComparison />
      </PageLayout>
    </div>
  );
}
